/* Creates namespacing so we don't have collisions in function or object names
 *
 * Example:
 *
 * var geocoder = abodo.maps.Geocoder(lat,lng);
 * geocoder.execute();
 *
 * @see classes/abodo_geocoder.js
 */

var abodo = window.abodo || {};
window.abodo = abodo;
abodo.actions = abodo.actions || {};
abodo.analytics = abodo.analytics || {};
abodo.components = abodo.components || {};
abodo.components.DataTable = abodo.components.DataTable || {};
abodo.components.events = abodo.components.events || {};
abodo.components.forms = abodo.components.forms || {};
abodo.containers = abodo.containers || {};
abodo.dtos = abodo.dtos || {};
abodo.helpers = abodo.helpers || {};
abodo.maps = abodo.maps || {};
abodo.modules = abodo.modules || {};
abodo.reducers = abodo.reducers || {};
abodo.services = abodo.services || {};
abodo.strings = abodo.strings || {};
abodo.workers = abodo.workers || {};

(function() {
  if (typeof module === "object") {
    module.exports = abodo;
  }
})();
